import countries from "i18n-iso-countries";
import { computed } from "mobx";
import { observer } from "mobx-react";
import React from "react";
import { InjectedIntlProps, injectIntl } from "react-intl";
import { compose } from "recompose";

import { DropdownOption } from "nvent-web/types/DropdownOption";
import { countryCodes } from "nvent-web/utils/countryCodes";

import { DropdownField } from "./DropdownField";
import { DropdownFieldProps } from "./DropdownField";

interface CountriesFieldProps extends Omit<DropdownFieldProps, "options"> {}

interface CountriesFieldInnerProps extends CountriesFieldProps, InjectedIntlProps {}

class CountriesFieldInner extends React.Component<CountriesFieldInnerProps> {
  @computed
  get countriesWithIsos(): DropdownOption[] {
    const { locale } = this.props.intl;
    return countryCodes.map((iso) => {
      return {
        key: iso,
        title: countries.getName(iso, locale),
      };
    });
  }

  render() {
    return <DropdownField options={this.countriesWithIsos} {...this.props} />;
  }
}

const CountriesField = compose<CountriesFieldInnerProps, CountriesFieldProps>(
  injectIntl,
  observer
)(CountriesFieldInner);
export default CountriesField;
